<template>
    <div class="myinfo">
        <div class="myinfo-heading">
            <h2>My physical info</h2>
            <p>Please keep this information updated for better customer service.</p>
        </div>

        <div class="myinfo-form">

            <div class="inp-group">
                <label for="myinfo-date">Date of birth</label>
                <date-picker :lang="datePikerLang" :format="'DD.MM.YYYY'" id="myinfo-date" input-class="inp-style inp-fw" type="date"
                             v-model="user.birth_date" valueType="YYYY-MM-DD"/>
            </div>

            <div class="inp-group flex">
                <label class="mb2x">{{trans.text.myInfo.gender}}</label>
                <div class="inp-row">

                    <label :class="{active: user.gender === 'female'}" class="inp-line gender-radio-label"
                           for="female-gender">
                        <input class="inp-decorate female gender-radio"
                               id='female-gender'
                               name="gender"
                               type="radio"
                               v-model="user.gender"
                               value="female">
                        <span>{{trans.text.myInfo.female}}</span>
                    </label>

                    <label :class="{active: user.gender === 'male'}" class="inp-line gender-radio-label"
                           for="male-gender">
                        <input class="inp-decorate male gender-radio"
                               id='male-gender'
                               name="gender"
                               type="radio"
                               v-model="user.gender"
                               value="male">
                        <span>{{trans.text.myInfo.male}}</span>
                    </label>

                    <label :class="{active: user.gender === 'free'}" class="inp-line gender-radio-label"
                           for="free-gender">
                        <input class="inp-decorate free gender-radio"
                               id='free-gender'
                               name="gender"
                               type="radio"
                               v-model="user.gender"
                               value="free">
                        <span>{{trans.text.myInfo.free}}</span>
                    </label>
                </div>
            </div>

            <div class="inp-group">
                <label>Number system</label>
                <multiselect
                    :allow-empty="false"
                    :label="'title'"
                    :limit="5"
                    :options="numberSystem"
                    :preselect-first="true"
                    :searchable="false"
                    :showNoResults="false"
                    :track-by="'id'"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    v-model="system">
                </multiselect>
            </div>

            <div class="inp-group">
                <label for="height-in">Height</label>
                <input class="inp-style inp-fw" v-model="user.height" id="height-in" name="#" type="number">
            </div>

            <div class="inp-group">
                <label for="weight-in">Weight</label>
                <input class="inp-style inp-fw"  v-model="user.weight" id="weight-in" name="#" type="number" >
            </div>

            <span class="resultVal">{{success}}</span>
            <span class="resultVal error" v-if="error">{{error}}</span>

            <div class="myinfo-btns">
                <button class="btn btn-green btn-submit" @click="updateInfo()">Save</button>
            </div>
        </div>
    </div>
</template>

<script>

    import DatePicker from "vue2-datepicker";
    import datePickerRu from "vue2-datepicker/locale/ru";
    import datePickerEn from "vue2-datepicker/locale/en";
    import datePickerDe from "vue2-datepicker/locale/de";
    import datePickerEs from "vue2-datepicker/locale/es";
    import datePickerFr from "vue2-datepicker/locale/fr";
    import 'vue2-datepicker/index.css';
    import {mapActions} from "vuex";
    import Multiselect from 'vue-multiselect';
    import language from "../../store/modules/language";

    export default {
        components: {Multiselect,DatePicker},
        props: ['lang', 'trans'],
        data() {
            return {
                datePikerLangs:[
                    {
                        id: 'en',
                        locale: datePickerEn,
                    },
                    {
                        id: 'es',
                        locale: datePickerEs,
                    },
                    {
                        id: 'de',
                        locale: datePickerDe,
                    },
                    {
                        id: 'fr',
                        locale: datePickerFr,
                    },
                    {
                        id: 'ru',
                        locale: datePickerRu,
                    },
                ],
                datePikerLang:datePickerEn,
                user: {
                    birth_date: "",
                    email: "",
                    f_name: "",
                    l_name: "",
                    gender: "",
                    weight: '',
                    height: '',
                    number_system:null,
                    mobile_phone: '',
                    email_verified_at: null,
                    ad_mailings: false
                },
                success: '',
                error: '',
                system:null,
                numberSystem:[
                    {
                        id:'metric',
                        title:'Metric',
                    },
                    {
                        id:'imperial',
                        title:'Imperial',
                    },
                ]
            }
        },
        methods: {
            ...mapActions(['ResendVerificationLink', 'Logout']),
            setDatepickerLang(){
                for (let datePikerLang of this.datePikerLangs){
                    if (this.lang === datePikerLang.id){
                        this.datePikerLang = datePikerLang.locale
                    }
                }
            },
            getInfo() {
                let that = this;
                axios
                    .get(this.$path + '/user', {headers: {Authorization: 'Bearer ' + localStorage.getItem('access_token')}})
                    .then(response => {
                        that.user.gender = response.data.gender;
                        that.user.birth_date = !!response.data.birth_date ? response.data.birth_date.split(' ')[0] : response.data.birth_date;
                        that.numberSystem.forEach(function (system) {
                            if (response.data.number_system  === system.id){
                                that.system = system
                            }
                        })
                        that.user.height = response.data.biometric_data.height;
                        that.user.weight = response.data.biometric_data.weight;

                        localStorage.setItem('user', JSON.stringify(response.data));
                    })
            },
            updateInfo() {
                let that = this;
                axios
                    .put(this.$path + '/updateUserInfo', {
                            'gender': this.user.gender,
                            'birth_date': this.user.birth_date,
                            'number_system': that.system.id,
                            'height': that.user.height,
                            'weight': that.user.weight,
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + localStorage.getItem('access_token')
                            }
                        })
                    .then(response => {
                        that.success = that.trans.text.myInfo.successUpdate;
                        that.error = '';

                        that.user.gender = response.data.user.gender;
                        that.user.birth_date = !!response.data.user.birth_date ? response.data.user.birth_date.split(' ')[0] : response.data.user.birth_date;
                        that.numberSystem.forEach(function (system) {
                            if (response.data.user.number_system  === system.id){
                                that.system = system
                            }
                        })
                        that.user.height = response.data.user.biometric_data.height;
                        that.user.weight = response.data.user.biometric_data.weight;


                        $('.' + response.data.user.gender).addClass('checked');

                        this.$store.commit('updateAuthUser', response.data.user);

                        localStorage.setItem('user', JSON.stringify(response.data.user));

                        setTimeout(() => {
                            this.success = null;
                            this.error = null;
                        }, 5000)
                    })
                    .catch(err => {
                        if (err.response.data && err.response.data.errors.email) {
                            that.error = err.response.data.errors.email[0]
                        }
                        that.success = ''

                        setTimeout(() => {
                            this.success = null;
                            this.error = null;
                        }, 5000)
                    })
            },
            changeGender(gender) {
                this.user.gender = gender
            },
        },
        mounted() {
            this.setDatepickerLang();
            if (!localStorage.getItem('access_token')) {
                location.href = `/${this.lang}/login`
            } else {
                this.getInfo();
            }
        }

    }
</script>
<style lang="scss" scoped>
    .inp-success__text {
        font-size: 14px;
        color: #000;
        /*color: #49cc90;*/
    }

    .resultVal {
        margin-bottom: 72px;
        display: block;
        margin-top: 36px;

        & + .inp-group__checkbox-typical {
            display: none;
        }
    }

    .error {
        font-size: 14px;
        color: #E41B1B;
    }

    .mx-datepicker {
        width: 100%;
    }

    .error-text-custom {
        padding-top: 7px;
        font-size: 14px;
        color: #E41B1B;
    }

    .black-link {
        color: #000000;

        &:hover {
            color: #979797;
        }
    }

    .gender-radio-label {
        position: relative;
        padding-left: 30px;
        height: 26px;

        &:before {
            content: '';
            border-radius: 50%;
            width: 26px;
            height: 26px;
            background: #efefef;
            position: absolute;
            left: 0;
            top: 0;
        }

        &.active {
            &:after {
                content: '';
                border-radius: 50%;
                width: 14px;
                height: 14px;
                background: #c2e900;
                position: absolute;
                left: 6px;
                top: 6px;
            }
        }

        input {
            display: none;
        }
    }
</style>
